// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentAgent_header__3kopW","title":"ShipmentAgent_title__1_GFJ","small":"ShipmentAgent_small__hl_lm","btnContainer":"ShipmentAgent_btnContainer__bMahr"};